import { AuthState } from './authReducer';
import { useAuthContext } from './useAuth';
import { useEffect } from 'react';
import { getRefreshToken } from '@xolv-mybrightlink/common';
import { useNavigate } from 'react-router-dom';

export const useAuthRedirect = (state: AuthState, redirectTo: string) => {
  const [currentState, dispatch] = useAuthContext();
  const navigate = useNavigate();
  console.debug('useAuthRedirect', currentState, state);
  useEffect(() => {
    dispatch(getRefreshToken() != null ? 'AUTHENTICATED' : 'UNAUTHENTICATED');
    if (currentState === state) {
      navigate(redirectTo);
    }
  });
};
